import { render, staticRenderFns } from "./addLaborSuplies.vue?vue&type=template&id=f3ea442a&scoped=true"
import script from "./addLaborSuplies.vue?vue&type=script&lang=js"
export * from "./addLaborSuplies.vue?vue&type=script&lang=js"
import style0 from "./addLaborSuplies.vue?vue&type=style&index=0&id=f3ea442a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ea442a",
  null
  
)

export default component.exports